import React from 'react';
import './GameViews/gameViews.css'
import { connect } from 'react-redux';
import { setInfo } from '../../redux/actionList';
import LinkCard from '../shared-components/link_card';
import MonthlyStatusModal from './monthly_status_modal';
import LeaderBoardModal from './leader_board_modal';
import FutureViewModal from './future_view_modal';
import MoodRetirementStatusModal from './mood_retirement_status_modal';
import InformationModal from '../shared-components/information_modal';
import determineCreditScore from './objectsEndOfTurn/determine_credit_score';
import CreditReportModal from './credit_report_modal';


// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    timeWizardInfo: state.timeWizardInfo
    // add other Redux state slices here if needed
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
};

class StatusDisplay extends React.Component {
    constructor(props) {
        super(props);
        this.props.onOpen();
        this.gameInfo = this.props.gameInfo();
        this.state = {
            modalOpen: false,
            allowed: true,
            firstTime: true,
            rerender: false,
            openCreditReport: false,
            openInformationModal: false,
        }    
        this.nextProcess = "";
        this.determineNbrMonths();
    }

determineNbrMonths(){
    this.nbrMonths = 1;
    if (this.gameInfo.timeWizardInfo.gameID  &&
    this.gameInfo.timeWizardInfo.status !== "inactive"){
        this.nbrMonths = +this.gameInfo.timeWizardInfo.monthsPerTurn - 1;
    }
}

selectMonthlyStatus() {
   
    this.creditScore = this.creditReport.creditScore;
    this.nextProcess = "monthlyStatus";
    this.setState({modalOpen: true});
}

selectLeaderBoard() {
    this.nextProcess = "leaderBoard";
    if (!this.props.accountNbr){
        this.accountNbr = "game";
    }else{
        this.accountNbr = this.props.accountNbr;
    }
    this.setState({modalOpen: true});
}

selectFutureView() {
    this.nextProcess = "futureView";
    this.setState({modalOpen: true});
}

selectMoodRetirementStatus() {
    this.nextProcess = "moodRetirementStatus";
    this.setState({modalOpen: true});
}

openStatusModal(){
    this.setState({modalOpen: true});
    this.nextProcess = "monthlyStatus";
}

closeModal() {
    this.setState({modalOpen: false});
    let prevProcess = this.props.prevProcess;
    if (prevProcess === "ChangeGameChoices" && this.nextProcess !== "creditReport"){
        this.nextProcess = "";
        this.props.clearPrevProcess();
        this.props.onNavigate("game-board");
    }
}

openCreditReportModal(){
    this.nextProcess = "creditReport";
    this.closeModal();
    this.setState({openCreditReport: true});
}

closeCreditReportModal(){
    this.nextProcess = "monthlyStatus";
    this.openStatusModal();
    this.setState({openCreditReport: false});
}

render() {
             
        if (this.props.prevProcess === "ParentPage"){
             this.title = "Display " + this.props.playerName + " Game Status"; 
        }else{
             this.title = "How Am I Doing?"
        }
        if (this.nextProcess !== ""){
            sessionStorage.setItem("GameViewSubProcess", this.nextProcess)
        }
       
        this.className = "col-sm-8 mt-1";
                
return <>
        
           <div className={this.className}>
           <div className="card mt-3 mr-2 rounded-corners-lg text-center game-board height-max">

               <h3 className="mt-2 text-center">{this.title}</h3>
           
            <span>
                <span className="row w-100 mx-0 ml-4 text-pointer">
                    <div className="col-sm-6 mt-4" onClick={() => this.selectMonthlyStatus()}>
                            <LinkCard name="Monthly Budget" imgSrc='./assets/GameStatus/Monthly.png'
                                 alt="" 
                            />
                      
                    </div>
                    <div className="col-sm-6 mb-2 mt-4" onClick={() => this.selectLeaderBoard()}>
                            <LinkCard name="Leader Board" imgSrc='./assets/GameStatus/leader.png' 
                                 alt="" />
                    </div> 
                </span>
                <span className="row w-100 mx-0 ml-4 text-pointer">
                   
                    <div className="col-sm-6 mt-2 mb-3" onClick={() => this.selectFutureView()}>
                           <LinkCard name="Future View" imgSrc='./assets/GameStatus/Future.png' 
                                alt="" />
                        
                    </div>
                    <div className="col-sm-6 mt-2 mb-3" onClick={() => this.selectMoodRetirementStatus()}>
                           <LinkCard name="Mood and Retirement Status" imgSrc='./assets/GameStatus/moodRetirementStatus.png' 
                                alt="" />
                        
                    </div>
                </span>
            </span>
            {this.nextProcess === "monthlyStatus" ?
                <MonthlyStatusModal modalOpen={this.state.modalOpen} 
                    creditScore={this.creditScore}
                    fromProcess={"status"}
                    onClose={() => this.closeModal()}
                    onOpen={() => this.openStatusModal()}
                    openCreditReportModal={() => this.openCreditReportModal()}
                    onNavigate={(pathname) => this.props.onNavigate(pathname)}
                    gameInfo = {() => this.props.gameInfo()}
                />
            :
                <div></div>
            }

            {this.nextProcess === "creditReport" ?
                <CreditReportModal
                    show={this.state.openCreditReport}
                    nbrMonths={this.nbrMonths}
                    user={this.gameInfo.gameData.user}
                    creditReport={this.creditReport}
                    creditInfo={this.gameInfo.creditCardInfo}
                    loanTable={this.gameInfo.gameData.loanTable}
                    onClose = {() => this.closeCreditReportModal()}
                />
            :
                null
            }
             {this.nextProcess === "leaderBoard" ?
                <LeaderBoardModal modalOpen={this.state.modalOpen} 
                    playerSelected={true}
                    accountNbr={this.accountNbr}
                    onClose={() => this.closeModal()} 
                />
            :
                <div></div>
            }
             {this.nextProcess === "futureView" ?
                <FutureViewModal modalOpen={this.state.modalOpen} 
                    onClose={() => this.closeModal()}
                    restartSw = {this.changeProcessSw}
                    gameInfo = {() => this.props.gameInfo()}
                />
            :
                <div></div>
            }

            {this.nextProcess === "moodRetirementStatus" ?
                <MoodRetirementStatusModal 
                    modalOpen={this.state.modalOpen} 
                    onClose={() => this.closeModal()}
                />
            :
                <div></div>
            }       

            {this.nextProcess === "InformationModal"   ?
                <InformationModal
                    time={6000}
                    show={this.state.openInformationModal}
                    infoCode={this.informationCode}
                    onClose={() => this.closeInformationModal()}
                />
            :
                null
            }

           
        </div>
        
        {this.props.prevProcess === "ParentPage" ?
                <div>
                    <button className="btn done-button-placement btn-primary ml-3 mt-4" onClick={() => this.props.onDone()}>
                            Done
                    </button>
                </div>
            :
                null
            }
            
   {/*     {process.env.NODE_ENV === 'development' && (
                        <div className="breakpoint-indicator" />
                        )}
    */}
    </div>   
</>
  }

componentDidMount(){
      this._isMounted = true;
       this.creditReport = determineCreditScore(this.gameInfo.creditCardInfo, 
            this.gameInfo.gameData.loanTable, this.gameInfo.gameData.currentGameDate,
            this.gameInfo.gameData.gameNbrMonths, this.props.timeWizardInfo );
       this.props.setInfoRedux(this.creditReport, "creditReport");
       if(this.state.timeout) clearTimeout(this.state.timeout);
                this.state.timeout = setTimeout(() => {
                this.checkForMessage()
            }, 300);
        
}


checkForMessage(){
    if ((this.props.prevProcess === "ChangeGameChoices" && this.state.modalOpen === false) ||
            (this.props.selected === "monthlyStatus" && this.state.firstTime === true)){
            if (this.props.prevProcess === "ChangeGameChoices"){
               this.nextProcess = "InformationModal";
               this.informationCode = "GameChangeComplete";
               this.setState({openInformationModal: true});
            }else{
                this.setState({modalOpen: true});
                this.nextProcess = this.props.selected;
            }
           
      }     
}

closeInformationModal(){
    this.setState({openInformationModal: false});
    this.selectMonthlyStatus();
    this.setState({firstTime: false});
}
 
}

export default connect(mapStateToProps, mapDispatchToProps)(StatusDisplay);